module.exports = __webpack_public_path__ + "static/media/036-toothache.642bc7ba.svg";